<template>
<DemoVideo
  title="Curl Demo"
  :demoVideo="videoFile"
  :navKeys="['demos', 'curl_demo']"
  :key="viewKey"
/>
</template>

<script>
import whoosh_curl from '../assets/whoosh_curl.mp4'

import DemoVideo from '@/components/DemoVideo.vue'

export default {
  data () {
    return {
      videoFile: whoosh_curl,
      viewKey: 1
    }
  },
  components: { DemoVideo },
  beforeRouteUpdate () {
    this.viewKey += 1
  }
}
</script>